<div mat-dialog-title class="flex">
  <h2>Edit Admin Info</h2>
  <app-close-button></app-close-button>
</div>

<mat-dialog-content [formGroup]="form">
  <div class="row">
    <mat-form-field class="col-md-12">
      <input matInput placeholder="Email" formControlName="email" required [disabled]="true">
    </mat-form-field>
  </div>

  <div class="row">
    <!-- First Name -->
    <mat-form-field class="col-md-6">
      <input matInput placeholder="First Name" formControlName="firstName">
    </mat-form-field>

    <!-- Last Name -->
    <mat-form-field class="col-md-6">
      <input matInput placeholder="Last Name" formControlName="lastName">
    </mat-form-field>
  </div>

  <div class="mb-2">
    <button class="mat-raised-button" (click)="close()">Close</button>
    <button class="mat-raised-button mat-primary ml-2" (click)="save()">Save</button>
  </div>
</mat-dialog-content>
